import { Location } from '@/types/models/Location.model'
import { Center } from '@/types/models'
import { MedicalBusiness } from 'schema-dts'
import { getPhoneNumbers } from '@/domain/center.js'

interface CenterSchema {
  (props: { center: Center; location: Location }): MedicalBusiness
}

const centerSchema: CenterSchema = ({ center, location }) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'MedicalBusiness',
    legalName: center.title,
    name: center.title,
    url: `https://recovery.com/${center.slug}/`,
    priceRange: center.pricing_label,
    telephone: getPhoneNumbers(center)[0]?.number,
    image: center.featured_image,
    geo: {
      '@type': 'GeoCoordinates',
      latitude: location?._geoloc?.lat,
      longitude: location?._geoloc?.lng
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: center.address
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
      ],
      opens: '00:00',
      closes: '23:59'
    }
  }
}

export default centerSchema
